class MiniCart extends HTMLElement {

  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');

    new IntersectionObserver(
      this.handleIntersection.bind(this)
    ).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {

        const miniCart =
          document.getElementById('mini-cart');

        if (miniCart) {
          miniCart.innerHTML =
            this.getSectionInnerHTML(
              html,
              '.shopify-section'
            );
        }

        document.dispatchEvent(
          new CustomEvent('cartdrawer:opened')
        );

      })
      .catch(error => {

        console.error(
          'Mini cart load error:',
          error
        );

      });
  }

  open() {

    if (!this.drawer) {
      this.drawer =
        document.querySelector('cart-drawer');
    }

    if (!this.drawer) return;

    const detailsElement =
      this.drawer.querySelector('details');

    if (!detailsElement) return;

    if (
      detailsElement.hasAttribute('open')
    ) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {

    this.productId =
      parsedState.id;

    this.getSectionsToRender()
      .forEach(section => {

        const element =
          document.getElementById(
            section.id
          );

        if (
          element &&
          parsedState.sections &&
          parsedState.sections[
            section.section
          ]
        ) {

          element.innerHTML =
            this.getSectionInnerHTML(
              parsedState.sections[
                section.section
              ],
              section.selector
            );

        }

      });

    this.open();
  }

  getSectionsToRender() {

    return [

      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },

      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },

      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }

    ];

  }

  getSectionInnerHTML(
    html,
    selector = '.shopify-section'
  ) {

    const parsedHTML =
      new DOMParser().parseFromString(
        html,
        'text/html'
      );

    const selectedElement =
      parsedHTML.querySelector(
        selector
      );

    return selectedElement
      ? selectedElement.innerHTML
      : '';

  }

}


if (!customElements.get('mini-cart')) {

  customElements.define(
    'mini-cart',
    MiniCart
  );

}


/* =========================================================
   VITYNE UPSELL
   ADD TO CART CONTROLLER

   Adds upsell as a REAL Shopify cart item.

   Shopify returns freshly rendered:
   - mini-cart
   - cart icon
   - mobile cart icon

   Then the existing MiniCart renderer updates everything.
========================================================= */

(function () {

  if (
    window.__vityneUpsellAddControllerV3
  ) {
    return;
  }

  window.__vityneUpsellAddControllerV3 =
    true;


  let busy = false;


  /* =======================================================
     SHOPIFY ROOT
  ======================================================= */

  function getShopifyRoot() {

    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {

      return window.Shopify.routes.root;

    }

    return '/';

  }


  /* =======================================================
     GET MINI CART
  ======================================================= */

  function getMiniCartElement() {

    return document.querySelector(
      'mini-cart'
    );

  }


  /* =======================================================
     GET SECTIONS SHOPIFY MUST RETURN
  ======================================================= */

  function getSections(miniCart) {

    return miniCart
      .getSectionsToRender()
      .map(function (section) {

        return section.section;

      });

  }


  /* =======================================================
     ADD UPSELL
  ======================================================= */

  async function addUpsell(
    variantId,
    miniCart
  ) {

    const sections =
      getSections(miniCart);


    const response =
      await fetch(
        getShopifyRoot() +
          'cart/add.js',
        {

          method: 'POST',

          headers: {

            'Content-Type':
              'application/json',

            'Accept':
              'application/json',

            'X-Requested-With':
              'XMLHttpRequest'

          },


          body: JSON.stringify({

            items: [

              {

                id:
                  Number(variantId),

                quantity:
                  1

              }

            ],


            sections:
              sections,


            sections_url:
              window.location.pathname

          })

        }
      );


    const data =
      await response
        .json()
        .catch(function () {

          return {};

        });


    if (!response.ok) {

      throw new Error(

        data.description ||
        data.message ||
        'Could not add product'

      );

    }


    return data;

  }


  /* =======================================================
     VERIFY PRODUCT EXISTS IN REAL CART
  ======================================================= */

  async function verifyCartItem(
    variantId
  ) {

    const response =
      await fetch(
        getShopifyRoot() +
          'cart.js',
        {

          method: 'GET',

          headers: {

            'Accept':
              'application/json',

            'X-Requested-With':
              'XMLHttpRequest'

          },

          cache: 'no-store'

        }
      );


    if (!response.ok) {

      throw new Error(
        'Could not verify cart'
      );

    }


    const cart =
      await response.json();


    const item =
      cart.items.find(
        function (cartItem) {

          return (
            String(
              cartItem.variant_id
            ) ===
            String(
              variantId
            )
          );

        }
      );


    return {
      cart: cart,
      item: item
    };

  }


  /* =======================================================
     FALLBACK REFRESH

     Used only if Shopify does not return section HTML.
  ======================================================= */

  async function fallbackRefresh() {

    const response =
      await fetch(

        window.location.pathname +

        '?sections=' +

        [
          'mini-cart',
          'cart-icon-bubble',
          'mobile-cart-icon-bubble'
        ].join(','),

        {

          method: 'GET',

          headers: {

            'Accept':
              'application/json',

            'X-Requested-With':
              'XMLHttpRequest'

          },

          cache:
            'no-store'

        }

      );


    if (!response.ok) {

      throw new Error(
        'Could not refresh cart'
      );

    }


    const sections =
      await response.json();


    const miniCart =
      getMiniCartElement();


    if (!miniCart) {
      return;
    }


    miniCart.renderContents({

      id: null,

      sections: sections

    });

  }


  /* =======================================================
     CLICK CONTROLLER
  ======================================================= */

  document.addEventListener(

    'click',

    async function (event) {


      const button =
        event.target.closest(
          '[data-vityne-upsell-add]'
        );


      if (!button) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();


      if (busy) {
        return;
      }


      if (
        button.dataset.loading ===
        'true'
      ) {
        return;
      }


      if (button.disabled) {
        return;
      }


      /* ===================================================
         VARIANT
      =================================================== */

      const variantId =
        Number(
          button.dataset.variantId
        );


      if (
        !variantId ||
        Number.isNaN(
          variantId
        )
      ) {

        console.error(
          'Vityne upsell: ' +
          'variant ID missing'
        );

        return;

      }


      /* ===================================================
         MINI CART
      =================================================== */

      const miniCart =
        getMiniCartElement();


      if (!miniCart) {

        console.error(
          'Vityne upsell: ' +
          '<mini-cart> not found'
        );

        return;

      }


      if (
        typeof miniCart
          .getSectionsToRender !==
        'function'
      ) {

        console.error(
          'Vityne upsell: ' +
          'MiniCart API unavailable'
        );

        return;

      }


      /* ===================================================
         BUTTON STATE
      =================================================== */

      const originalText =
        button.textContent.trim() ||
        'Add to cart';


      try {


        busy = true;


        button.dataset.loading =
          'true';


        button.disabled =
          true;


        button.classList.add(
          'is-loading'
        );


        button.textContent =
          'Adding...';


        /* =================================================
           STEP 1
           ADD REAL PRODUCT TO SHOPIFY
        ================================================= */

        const data =
          await addUpsell(
            variantId,
            miniCart
          );


        /* =================================================
           STEP 2
           VERIFY PRODUCT REALLY EXISTS
        ================================================= */

        const verification =
          await verifyCartItem(
            variantId
          );


        if (
          !verification.item
        ) {

          throw new Error(
            'Product was not found in cart after adding'
          );

        }


        /* =================================================
           STEP 3
           TEMPORARY SUCCESS
        ================================================= */

        button.textContent =
          'Added';


        /* =================================================
           STEP 4
           RENDER FRESH SHOPIFY CART

           This is what makes the upsell appear as
           a normal cart product.
        ================================================= */

        if (
          data.sections &&
          data.sections[
            'mini-cart'
          ]
        ) {

          miniCart.renderContents(
            data
          );

        } else {

          await fallbackRefresh();

        }


        /* =================================================
           STEP 5
           CART EVENTS
        ================================================= */

        document.dispatchEvent(

          new CustomEvent(
            'cart:updated',
            {

              detail: {

                source:
                  'vityne-upsell',

                variantId:
                  variantId,

                cart:
                  verification.cart

              }

            }
          )

        );


        document.dispatchEvent(

          new CustomEvent(
            'cartdrawer:opened'
          )

        );


      } catch (error) {


        console.error(
          'Vityne upsell error:',
          error
        );


        button.disabled =
          false;


        button.dataset.loading =
          'false';


        button.classList.remove(
          'is-loading'
        );


        button.textContent =
          originalText;


        alert(

          error.message ||

          'Something went wrong. ' +
          'Please try again.'

        );


      } finally {


        busy = false;


        /*
         * After successful rendering,
         * the original button may have
         * been removed from the DOM.
         */

        if (
          button.isConnected
        ) {

          button.dataset.loading =
            'false';


          button.classList.remove(
            'is-loading'
          );

        }


      }


    },

    true

  );


})();